import { Portal, PortalProps } from "@/components/portal/Portal";

export const VaultObjectModalPortal = ({ children }: PortalProps) => {
  return <Portal root={"vault-object-modal-root"}>{children}</Portal>;
};
